import { render, staticRenderFns } from "./SJT.vue?vue&type=template&id=013d0833&scoped=true&"
import script from "./SJT.vue?vue&type=script&lang=js&"
export * from "./SJT.vue?vue&type=script&lang=js&"
import style0 from "./SJT.vue?vue&type=style&index=0&id=013d0833&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013d0833",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/owiwi.co.uk/staging-sjt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('013d0833', component.options)
    } else {
      api.reload('013d0833', component.options)
    }
    module.hot.accept("./SJT.vue?vue&type=template&id=013d0833&scoped=true&", function () {
      api.rerender('013d0833', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SJT.vue"
export default component.exports